import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const autoGridCss = ":host{display:grid;grid-template-columns:repeat(var(--partition-mode), minmax(var(--min-item-width), 1fr));grid-gap:var(--grid-gap)}";

const gapSizes = {
  none: '0',
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
};
const minWidths = {
  xs: '5rem',
  sm: '10rem',
  md: '15rem',
  lg: '20rem',
  xl: '30rem',
};
const AutoGrid = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.minItemWidth = 'md';
    this.gridGap = 'md';
    this.partitionMode = 'fill';
  }
  render() {
    var _a;
    return (h(Host, { style: {
        '--grid-gap': this.gridGap
          .split(' ')
          .map((g) => { var _a; return (_a = gapSizes[g]) !== null && _a !== void 0 ? _a : g; })
          .join(' '),
        '--min-item-width': (_a = minWidths[this.minItemWidth]) !== null && _a !== void 0 ? _a : this.minItemWidth,
        '--partition-mode': `auto-${this.partitionMode}`,
      } }, h("slot", null)));
  }
  static get style() { return autoGridCss; }
}, [1, "tt-auto-grid", {
    "minItemWidth": [1, "min-item-width"],
    "gridGap": [1, "grid-gap"],
    "partitionMode": [1, "partition-mode"]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-auto-grid"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-auto-grid":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, AutoGrid);
      }
      break;
  } });
}

export { AutoGrid as A, defineCustomElement as d };
